import CONSTANTS from '@/constants'
import router from '@/router';

const auth = {
  namespaced: true,

  state: {
    apiToken: "",
    dealerMode: false,
    isAuthorizedToUseDashboard: false
  },

  getters: {
    doesSessionDataBelongsToDealer: () => (sessionData) => {
      return sessionData.rhino_code.toLowerCase() === router.currentRoute.params.dealer_code.toLowerCase()
    }
  },

  actions: {

    async dealerLogin({ dispatch }, passcode) {
      try {
        await dispatch('dealer/getDealerInProject', passcode, { root: true })
      } catch (error) {
        throw new Error(error);
      }
    },

    dealerLogout({ dispatch, commit }) {
      sessionStorage.removeItem(CONSTANTS.GAMEPLAN_SESSION)
      commit("SET_API_TOKEN", null);
      commit("SET_DEALER_MODE", false);
      dispatch('project/setPreviewMode', null, { root: true })
    },

    async checkIfSessionExists({ getters, dispatch }) {

      if (sessionStorage.getItem(CONSTANTS.GAMEPLAN_SESSION)) {
        const sessionData = await dispatch('getSessionData')
        return getters['doesSessionDataBelongsToDealer'](sessionData)
      } else {
        return false
      }
    },

    async getSessionData() {
      try {
        return await JSON.parse(sessionStorage.getItem(CONSTANTS.GAMEPLAN_SESSION))
      } catch (e) {
        console.log(e);
        throw new Error(e)
      }
    },

    async saveSessionData(_, sessionData) {

      try {
        const sessionDataStringified = await JSON.stringify(sessionData)
        sessionStorage.setItem(CONSTANTS.GAMEPLAN_SESSION, sessionDataStringified)

      } catch (e) {
        console.log(e);
        throw new Error(e)
      }

    },

    setApiToken({ commit }, token) {
      commit('SET_API_TOKEN', token)
    },

    setDealerMode({ commit }, boolean) {
      commit('SET_DEALER_MODE', boolean)
    },

    setAuthorizedToUseDashboard({ commit }, boolean) {
      commit('SET_AUTHORIZED_TO_USE_DASHBOARD', boolean)
    },
  },

  mutations: {

    SET_API_TOKEN: (state, token) => {
      state.apiToken = token;
    },

    SET_DEALER_MODE: (state, boolean) => {
      state.dealerMode = boolean
    },
    SET_AUTHORIZED_TO_USE_DASHBOARD: (state, boolean) => {
      state.isAuthorizedToUseDashboard = boolean
    }

  }
}

export default auth